import { render, staticRenderFns } from "./AbkPopularSearchesBox.vue?vue&type=template&id=a43019fe&scoped=true&"
import script from "./AbkPopularSearchesBox.vue?vue&type=script&lang=js&"
export * from "./AbkPopularSearchesBox.vue?vue&type=script&lang=js&"
import style0 from "./AbkPopularSearchesBox.vue?vue&type=style&index=0&id=a43019fe&scoped=true&lang=scss&"
import style1 from "./AbkPopularSearchesBox.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a43019fe",
  null
  
)

export default component.exports